module.exports = __webpack_public_path__ + "static/media/CTIC_Banner.6781b793.jpg";